var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Util from '../utils/Util';
import { Method } from '../../common/Constants';
import Core from '../Core';
export default class NQSRequest {
    constructor(isHttps, host, service, method, params, body, onSuccess, onFail) {
        this.method = Method.GET;
        this.xhr = new XMLHttpRequest();
        this.retries = 0;
        this.isHttps = isHttps;
        this.host = host;
        this.service = service;
        this.method = method;
        this.params = {};
        if (method == Method.POST && !body) {
            if (params['code'])
                this.params['code'] = params['code'];
            this.params['sessionRoot'] = params['sessionRoot'] || Core.getInstance().getFastDataSessionToken();
            this.body = JSON.stringify(params);
        }
        else {
            this.params = params;
            this.body = body;
        }
        this.onSuccessCallback = onSuccess;
        this.onFailCallback = onFail;
    }
    performHttps() {
        return this.isHttps;
    }
    getHost() {
        return this.host;
    }
    getService() {
        return this.service;
    }
    getMethod() {
        return this.method;
    }
    getParams() {
        return this.params;
    }
    getBody() {
        return this.body;
    }
    setBody(body) {
        this.body = body;
    }
    getRetries() {
        return this.retries;
    }
    /**
     * Performs the request to the specified host and service
     *
     * @param sendFail Callback to when the send fails
     * @param onSucess Callback to when the send succeeds (optional)
     */
    send(sendFail, onSuccess) {
        this.xhr.open(this.method, this.getUrl());
        this.xhr.onreadystatechange = () => {
            if (this.xhr.readyState === 4 && this.xhr.status >= 200 && this.xhr.status < 400) {
                if (onSuccess) {
                    onSuccess();
                }
                if (this.onSuccessCallback) {
                    this.onSuccessCallback();
                }
            }
            else if (this.xhr.readyState === 4) {
                this.retries++;
                sendFail();
                if (this.onFailCallback) {
                    this.onFailCallback();
                }
            }
        };
        this.xhr.send(this.body);
    }
    asyncSend() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.send(reject, resolve);
            });
        });
    }
    getUrl() {
        const scheme = !this.isHttps ? 'http' : 'https';
        return `${scheme}://${this.host}${this.service}${Util.toQueryString(this.params)}`;
    }
}
